const DEFAULT_INDIA_LOCATION = { lat: 20.5937, lng: 78.9629 }

const LocationService = {
  getLocation: async () => {
    return { ...DEFAULT_INDIA_LOCATION }
  },
}

export default LocationService
